export default __webpack_public_path__ + "static/media/play_icon.43fc39d0.svg";